// Static language list - uses native names (UX best practice: users can find their language regardless of UI language)
export const languageList = {
  sv: "Svenska",
  no: "Norsk",
  fi: "Finnish",
  da: "Dansk",
  es: "Español",
  de: "Deutsch",
  it: "Italiano",
  en: "English",
};

// Translation key mapping for language names
export const languageTranslationKeys = {
  sv: "language_name_swedish",
  no: "language_name_norwegian",
  fi: "language_name_finnish",
  da: "language_name_danish",
  es: "language_name_spanish",
  de: "language_name_german",
  it: "language_name_italian",
  en: "language_name_english",
};

// Static list (backward compatibility) - uses native names
const languages = [
  { value: "da", text: "Dansk" },
  { value: "de", text: "Deutsch" },
  { value: "en", text: "English" },
  { value: "es", text: "Español" },
  { value: "fi", text: "Finnish" },
  { value: "it", text: "Italiano" },
  { value: "no", text: "Norsk" },
  { value: "sv", text: "Svenska" },
];

// Static list (backward compatibility) - uses native names
export const languagesMinimal = [
  { value: "sv", label: "Svenska" },
  { value: "en", label: "English" },
  { value: "fi", label: "Finnish" },
  { value: "no", label: "Norsk" },
  { value: "da", label: "Dansk" },
  { value: "de", label: "Deutsch" },
  { value: "es", label: "Español" },
];

// Translatable getter function - returns language options with translated labels
export const getLanguagesMinimal = (t) => [
  { value: "sv", label: t("language_name_swedish") },
  { value: "en", label: t("language_name_english") },
  { value: "fi", label: t("language_name_finnish") },
  { value: "no", label: t("language_name_norwegian") },
  { value: "da", label: t("language_name_danish") },
  { value: "de", label: t("language_name_german") },
  { value: "es", label: t("language_name_spanish") },
];

// Translatable getter function - returns language list object with translated names
export const getLanguageList = (t) => ({
  sv: t("language_name_swedish"),
  no: t("language_name_norwegian"),
  fi: t("language_name_finnish"),
  da: t("language_name_danish"),
  es: t("language_name_spanish"),
  de: t("language_name_german"),
  it: t("language_name_italian"),
  en: t("language_name_english"),
});

export const storeLanguages = ["sv", "en", "fi"];
export const storefrontLanguagePreset = ["sv", "en", "no", "fi", "da", "de", "es"];

export const ALL_LANGUAGE_VALUE = "all";

// Static list (backward compatibility)
export const LANGUAGE_FILTER_OPTIONS = [
  { value: "sv", label: "Swedish" },
  { value: "en", label: "English" },
  { value: "no", label: "Norwegian" },
  { value: "fi", label: "Finnish" },
  { value: "da", label: "Danish" },
  { value: "de", label: "German" },
  { value: "es", label: "Spanish" },
];

// Translatable getter function - returns filter options with translated labels
export const getLanguageFilterOptions = (t) => [
  { value: "sv", label: t("language_name_swedish") },
  { value: "en", label: t("language_name_english") },
  { value: "no", label: t("language_name_norwegian") },
  { value: "fi", label: t("language_name_finnish") },
  { value: "da", label: t("language_name_danish") },
  { value: "de", label: t("language_name_german") },
  { value: "es", label: t("language_name_spanish") },
];

export default languages;
